import { skipToken, useQuery } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { endpoints } from '@/modules/companies/constants';

import { companiesQueryKeys } from './queryKeys';

/** Skipped while `companyId` is undefined. */
export const useCompanyInboundSettingsQuery = (companyId: string | undefined) =>
  useQuery({
    queryKey: companiesQueryKeys.inbound(companyId ?? ''),
    queryFn: companyId
      ? async () => {
          const { data } = await fetchClient.GET(endpoints.companyInbound, {
            params: { path: { id: companyId } },
          });
          return data;
        }
      : skipToken,
  });
